import { formatISO } from "date-fns";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import DateRangeType from "../enums/DateRangeType";

const dateRangeFilterToRange = (
  dateRange: DateRange | undefined,
  dateRangeType: DateRangeType
): string => {
  if (dateRangeType !== DateRangeType.CUSTOM) {
    return dateRangeType;
  }

  if (dateRange) {
    return `${formatISO(dateRange.startDate, { representation: "date" })}_${formatISO(
      dateRange.endDate,
      {
        representation: "date",
      }
    )}`;
  }

  return DateRangeType.YESTERDAY;
};

export default dateRangeFilterToRange;
